import { useMaybeSetupPushNotifications } from "open-modules/zdf/platform-specific/pushNotifs"
import { useSiloKey } from "util/datastore"
import { Feature } from "util/stdtypes"
import { QuestionConfig } from "structure/question"

export const HandlePushNotificationsFeature: Feature<QuestionConfig, {}> = {
    name: 'Handle Push Notifications',
    key: 'handlepushnotifications',
    dev: true,
    config: {
        topBanners: [HandlePushNotificationsComponent],
    }
}

function HandlePushNotificationsComponent(){
    const siloKey = useSiloKey()
    useMaybeSetupPushNotifications(siloKey)
    return null
}